/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing health score related components.
 * @module HealthScoreModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { VIPModule } from '@vmw/ngx-vip';
import { ClrSpinnerModule } from '@clr/angular';
import { TooltipModule } from 'ng/modules/tooltip/tooltip.module';
import { SharedModule } from 'ng/shared/shared.module';

import {
    AviAreaChartComponent,
    AviHealthScoreBarComponent,
    AviHealthScoreBarsComponent,
    AviHealthScoreBodyComponent,
    AviHealthScoreComponent,
    AviHealthScoreDownComponent,
    AviHealthScoreErrorComponent,
    AviHealthScoreFaultsComponent,
    AviHealthScoreFooterComponent,
    HealthScoreClassPipe,
    OperationalStateIconComponent,
    OperationalStateIconStatusPipe,
} from '.';

const components = [
    AviAreaChartComponent,
    AviHealthScoreBarComponent,
    AviHealthScoreBarsComponent,
    AviHealthScoreBodyComponent,
    AviHealthScoreComponent,
    AviHealthScoreDownComponent,
    AviHealthScoreErrorComponent,
    AviHealthScoreFaultsComponent,
    AviHealthScoreFooterComponent,
    OperationalStateIconComponent,
];

const pipes = [
    HealthScoreClassPipe,
    OperationalStateIconStatusPipe,
];

@NgModule({
    declarations: [
        ...components,
        ...pipes,
    ],
    exports: [
        AviHealthScoreComponent,
        HealthScoreClassPipe,
        OperationalStateIconComponent,
        OperationalStateIconStatusPipe,
    ],
    imports: [
        ClrSpinnerModule,
        CommonModule,
        OverlayModule,
        SharedModule,
        TooltipModule,
        VIPModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class HealthScoreModule {}
